module.exports = __webpack_public_path__ + "img/platform-event.87f10d90.png";